<script>
import ModalLiveClassComponent from '../../features/modals/ModalLiveClassComponent';
export default {
  name: 'ModalLiveClassView',
  extends: ModalLiveClassComponent,
};
</script>

<template>
  <el-dialog
    v-model="conf.isVisible"
    title="Clase en vivo"
    width="35%"
    class="live-class-modal"
    append-to-body
    :before-close="onCancel"
    :close-on-click-modal="false"
  >
    <el-form
      ref="formData"
      v-loading="conf.isLoading"
      :model="formData"
      :rules="rules"
      status-icon
      :label-position="'top'"
    >
      <fieldset>
        <legend>Información de Clases en Vivo</legend>
        <el-row
          type="flex"
          class="row-bg"
          :gutter="20"
        >
          <el-col :span="24">
            <el-form-item label="Curso">
              <el-select
                v-model="formData.course"
                clearable
                filterable
                remote
                :remote-method="onSearchCourse"
                placeholder="Seleccionar"
                value-key="id"
                size="small"
              >
                <el-option
                  v-for="item in courses"
                  :key="item.id"
                  :label="item.title"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          v-if="formData.state == 'update'"
          type="flex"
          class="row-bg"
          :gutter="20"
        >
          <el-col :span="24">
            <el-form-item label="Publicado por:">
              <el-select
                v-model="formData.publisher"
                filterable
                clearable
                remote
                placeholder="Buscar por nombre y seleccionar resultado para agregar"
                :remote-method="onSearchInstructors"
              >
                <el-option
                  v-for="item in instructors"
                  :key="item.id"
                  :label="mapPublisherName(item)"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          type="flex"
          class="row-bg"
          :gutter="20"
        >
          <el-col :span="24">
            <el-form-item
              label="Titulo"
              prop="title"
            >
              <el-input
                v-model="formData.title"
                size="small"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          type="flex"
          class="row-bg"
          :gutter="20"
        >
          <el-col :span="24">
            <el-form-item
              label="Descripción"
              prop="description"
            >
              <el-input
                v-model="formData.description"
                type="textarea"
                :row="3"
                maxlength="255"
                size="small"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          class="row-bg"
          :gutter="20"
        >
          <el-col
            :xs="24"
            :sm="18"
            :md="18"
            :lg="18"
            :xl="18"
          >
            <el-form-item
              label="Url de Stream"
              prop="streamUrl"
              required
            >
              <el-input
                v-model="formData.streamUrl"
                size="small"
                placeholder="https://www.youtube.com/embed/code_video"
              />
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :sm="6"
            :md="6"
            :lg="6"
            :xl="6"
          >
            <el-form-item
              label="Stream Finalizado"
              prop="isFinished"
            >
              <el-switch
                v-model="formData.isFinished"
                active-color="#13ce66"
                active-text="SI"
                inactive-text="NO"
                size="small"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </fieldset>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button
          size="small"
          class="btn-cancel"
          @click="onCancel"
        >Cancelar</el-button>
        <el-button
          type="primary"
          :disabled="!onCanSaveOrUpdate()"
          class="btn-primary"
          size="small"
          @click="onSubmitForm('formData')"
        >Guardar</el-button>
      </span>
    </template>
  </el-dialog>
</template>
